import React from 'react';

type DefaultSubmissionZoneProps = {
    submitText : string,
    cancelText? : string,
    onCancel?: () => void
}

const DefaultSubmissionZone = (props: DefaultSubmissionZoneProps) => {
    const {submitText, cancelText} = props
    return (
        <div className="submission-wrapper">
            <button type="submit" className="submit-button">{submitText}</button>
            {cancelText ? <button type="button" className="cancel-button" onMouseUp={() => props.onCancel?.()}>{cancelText}</button> : null}
        </div>
    );
}

export default DefaultSubmissionZone;
